import React, {Component} from "react";
import {storage, firestore} from "../../js/firebase";
import swal from "sweetalert2";
import FichaAudioInterior from "./FichaAudioInterior";

class FormAudioPathbook extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pathbooksLista: props.dataGeneral.listaPathbooks,
			selectPathbooks: [],
			/////pathbook lista
			urlIni: "https://firebasestorage.googleapis.com/v0/b/pathbook.appspot.com/o/pathbooks%2F",
			urlmid: "%2Faudios%2Fes-MX%2F",
			urlEnd: "?alt=media",
			referenceIni: "gs://pathbook.appspot.com/pathbooks/",
			referenceMid: "/audios/es-MX/",
			audioNull: "https://livingabook.com/LoadPathbooksAndMore/assets/img/portadaNull.jpg",
			audioACargar: null,
			barraLoad4: 0,
			barraLoadEnd4: 1000,
			message4: "Seleciona un archivo .JPG o .PNG para cargar",
			pathbookSeleccionado: "",
			audioDatos: [],
			pathbooksInfo: null,
		};
		this.manejadorCambios = this.manejadorCambios.bind(this);
	}

	manejadorCambios(event) {
		const name = event.target.name;
		this.setState({
			[name]: event.target.value,
		});
	}

	async validaPathbooksExiste() {
		if (!this.state.pathbookSeleccionado) {
			swal.fire({title: "Seleciona un pathbook existente", text: "Gracias", type: "error", confirmButtonText: "Entendido"});
		} else {
			let pathbookId = this.state.pathbookSeleccionado.split(" -   --> ");
			await firestore.doc("pathbooks/" + pathbookId[1]).get().then((documentSnapshot) => {
				let datapathbook = documentSnapshot;
				if (datapathbook.exists === true) {
					this.setState({pathbooksInfo: datapathbook});
					if(datapathbook.data().audiosInt){
						this.setState({audioDatos: datapathbook.data().audiosInt,});
					}
				} else {
					swal.fire({title: "Ese pathbook no existe", text: "ingresa uno correcto para continuar ", type: "error", confirmButtonText: "Entendido"});
				}
			});
		}
		console.log(this.state.audioDatos.file)
	}

	async cargaAudio(event) {
		const file = event.target.files[0];
		const storageRef = storage.ref("pathbooks/" + this.state.pathbooksInfo.id + "/audios/es-MX").child(file.name);
		let cadenaSave = []
		let urlCadena = this.state.urlIni + this.state.pathbooksInfo.id + this.state.urlmid + file.name + this.state.urlEnd
		let referenceCadena = this.state.referenceIni + this.state.pathbooksInfo.id + this.state.referenceMid + file.name
		let fileCadena = file.name
		let existe = false
		// let cadenaSave = this.state.urlIni + this.state.pathbooksInfo.id + this.state.urlmid + task.snapshot.metadata.name + this.state.urlEnd
		 await this.state.audioDatos.forEach((task) => {
		 	if (cadenaSave === task){
				existe = true
				    swal.fire({
					    title: "Este audio ya existe",
					    text: "El nombre de esta audio ya existe",
					    type: "error",
					    confirmButtonText: "Entendido",
				    });

			}
		 });
		if (existe === false){
			const task = storageRef.put(file);
			task.on("state_changed", (snapshot) => {
				this.setState({
					barraLoadEnd4: snapshot.totalBytes,
					barraLoad4: snapshot.bytesTransferred,
				});
			}, (error) => {
				this.setState({
					message4: "Error: " + error,
				});
			}, () => {
				this.setState({
					message4: "Cargado correctamente",
					audioACargar: urlCadena
				});
				this.guarda();
			});
			this.state.audioDatos.push({
				url: urlCadena,
				reference: referenceCadena,
				file: fileCadena
				});
		}
	}

	async guarda() {
		await firestore.collection("pathbooks").doc(this.state.pathbooksInfo.id).update({
			audiosInt: this.state.audioDatos
		});
		this.validaPathbooksExiste();
	}

	async componentDidMount() {
		/////lista de pathbooks
		let selectPathbookList = [];
		await this.state.pathbooksLista.forEach((task) => {
			let idPathbook = task.doc.id;
			let nombrePathbook = task.doc.data().title["es"];
			selectPathbookList.push({id: idPathbook, nombre: nombrePathbook});
		});
		await this.setState({selectPathbooks: selectPathbookList});
		//console.log(this.state.selectPathbooks)
		//this.listaDeImagenes()
	}



	render() {
		return (
			<div className="content-wrapper">

				<div className="content-header">
					<h2 className="panel-title">Audios de Pathbook</h2>
				</div>
				<div className="content-header">
					<div className="card card-primary">
						<div className="card-header">
							<h3 className="card-title">Busca Pathbook</h3>
						</div>

						<div className="d-flex">
							<div className="card-body">
								<div className="container">
									<div className="row">
										<div className="col-sm">
											<div className="form-group">
												<div className="container">
													<label>Si quieres editar audios a un pathbook Buscalo aqui:</label>
													<div className="row">
														<input className="form-control" list="selectPathbook" id="generoSelected" name="pathbookSeleccionado" type="select" placeholder="Elige un pathbook a modificar" value={this.state.pathbookSeleccionado} onChange={this.manejadorCambios}/>
														<datalist id="selectPathbook">
															{this.state.selectPathbooks.map(task => <option key={task.id + "key"} value={task.nombre + " -   --> " + task.id}>{task.nombre}</option>)}
														</datalist>
													</div>
												</div>
												<br/>
												<div className="form-group">
													{/*validaBuscadorPathbook*/}
													<button onClick={() => this.validaPathbooksExiste()} type="button" id="buttonPathbook" className="btn btn-primary btn-lg btn-block">Seleccionar pathbook</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="d-flex">
							<div className="card-body">
								{
									!this.state.pathbooksInfo
										? (
											<div>
												<label>Selecciona un pathbook:</label>
											</div>)
										:
										<div>
											<label>Pathbook selecionado</label>
											<h3>{this.state.pathbooksInfo.data().title["es"]}</h3>
											<div className="container">
												<h6>Carga una audio</h6>
												<div className="row row-inputs">
													<progress value={this.state.barraLoad4} max={this.state.barraLoadEnd4}/>
												</div>
												<div className="row row-inputs">
													<br/>
													<div className="input-group mb-3">
														<div className="custom-file">
															<input type="file" accept="audio/mp3,audio/mp4" className="custom-file-input" onChange={this.cargaAudio.bind(this)}/>
															<label className="custom-file-label" htmlFor="inputGroupFile02">Tipo .mp3 .mp4</label>
														</div>
													</div>
													<div className="input-group mb-3">
														{this.state.message4}
													</div>
													<br/>
												</div>
												<br/>
											</div>
											<div className="container">
												{this.state.audioDatos.map(data => (
													<div key={data.file}>
														<FichaAudioInterior data={data}/>
													</div>
												))}
											</div>

											<br/>
											<br/>
											<br/>
											<label>Cadenas</label>
											<label>Url:</label>
											<h5>{this.state.urlIni}{this.state.pathbooksInfo.id}{this.state.urlmid}</h5>
											<h5>{this.state.urlEnd}</h5>
											<br/>
											<label>Referencia:</label>
											<h5>{this.state.referenceIni}{this.state.pathbooksInfo.id}{this.state.referenceMid}</h5>
											<br/>
										</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);

	}
}

export default FormAudioPathbook;

